export const MOBILE_BREAKPOINT = 1024; // px — lato corto dello schermo fisico

export function isMobile() {
  return /android|iphone|ipad|ipod|windows phone|blackberry|opera mini|mobile/i
    .test(navigator.userAgent);
}

export function isDesktop() {
  return !isMobile();
}